<script>
import PageImage from "../pages/page-image";
import InventoryDetails from "../inventories/inventory-details";

/**
 * Nav-bar Component
 */
export default {
  components: {
    InventoryDetails,
    PageImage,
  },
  props: {
    page: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      singleImage: false,
      displayedInventory: null
    };
  },
  methods: {
    formatAdresse(item) {
      let adresse = '';

      if (item.Adresse !== '' && item.Adresse !== ' ')
        adresse += `<a href="#">${item.Adresse}</a>`;
      if (item.Ville !== '' && item.Ville !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + `<a href="#">${item.Ville}</a>`;
      if (item.Region !== '' && item.Region !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + `<a href="#">${item.Region}</a>`;
      if (item.Pays !== '' && item.Pays !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + `<a href="#">${item.Pays}</a>`;

      return adresse;
    },
    formatDate(item) {
      let date = '';

      if (item.DateJour !== '' && item.DateJour !== ' ')
        date += item.DateJour;
      if (item.DateMois !== '' && item.DateMois !== ' ')
        date += (date !== '' ? '/' : '') + item.DateMois;
      if (item.DateAnnee !== '' && item.DateAnnee !== ' ')
        date += (date !== '' ? '/' : '') + item.DateAnnee;
      if (item.DetailDate !== '' && item.DetailDate !== ' ')
        date += (date !== '' ? ', ' : '') + item.DetailDate;

      return date;
    },
    formatTheme(item) {
      let theme = '';

      if (item.Theme !== '' && item.Theme !== ' ')
        theme += `<a href="#">${item.Theme}</a>`;
      if (item.DetailTheme !== '' && item.DetailTheme !== ' ')
        theme += (theme !== '' ? ', ' : '') + item.DetailTheme;

      return theme;
    },
    getNumAlbum(item) {
      let imageNumber = item.NumPageAlbum;
      let annee = imageNumber.substr(imageNumber.length - 2);

      return '19' + annee;
    },
  }
};
</script>

<template>
  <b-card no-body>
    <b-row no-gutters class="align-items-center">
      <b-col md="4">
        <page-image :page="page"></page-image>
      </b-col>
      <b-col md="8">
        <b-card-body :title="page.NumPageAlbum">
          <b-card-text>
            <i class='bx bx-photo-album'></i> <a href="javascript: void(0);">{{ getNumAlbum(page) }}</a>
          </b-card-text>
          <b-card-text>
            <i class='bx bx-calendar'></i> <span v-html="formatDate(page)"></span>
          </b-card-text>
          <b-card-text v-if="formatAdresse(page) !== ''">
            <i class='bx bx-map'></i> <span v-html="formatAdresse(page)"></span>
          </b-card-text>
          <b-card-text v-if="formatTheme(page) !== ''">
            <i class='bx bx-purchase-tag'></i> <span v-html="formatTheme(page)"></span>
          </b-card-text>
          <b-card-text v-if="page.inventories && page.inventories.length">
            <i class='bx bx-hash'></i>
            <span
                v-for="(inventory, key) in page.inventories"
                :key="key"
            >
              <a role="button" v-b-modal.modal-page-details @click="displayedInventory = inventory" class="text-info ms-2">{{ inventory.inventory_number }}</a>
            </span>
          </b-card-text>
          <b-row>
            <b-col md="6" class="card-text" v-if="page.Inscription !== ' '">
              <h6>Inscription</h6>
              <blockquote class="blockquote">
                {{ page.Inscription }}
              </blockquote>
            </b-col>
            <b-col md="6" class="card-text" v-if="page.Commentaire !== ' '">
              <h6>Commentaire</h6>
              <blockquote class="blockquote">
                {{ page.Commentaire }}
              </blockquote>
            </b-col>
          </b-row>
        </b-card-body>
      </b-col>
    </b-row>

    <b-modal id="modal-page-details" centered hide-footer
             size="xl"
             title-class="font-18">
      <inventory-details v-if="displayedInventory" :inventory="displayedInventory"></inventory-details>
    </b-modal>
  </b-card>
</template>
